import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { REVEAL, revealDelayed } from "@/lib/motion";

const OFFERS = [
  {
    name: "Outbound Engine Build",
    price: "S$3,000",
    body: "A working outbound engine for one target customer and one market, live in 2 weeks. Includes an enriched list of 500 contacts.",
    cta: "See what's included",
    to: "/outbound-engine-build",
    testId: "offer-outbound-engine-build",
  },
  {
    name: "Custom AI Sales Workflows",
    price: "Priced after a discovery call",
    body: "For businesses that need more than outbound: enquiry handling, follow-up, booking, CRM automation and reporting.",
    cta: "Book a discovery call",
    to: "/custom-workflows",
    testId: "offer-custom-workflows",
  },
];

export const HomeOffers = () => (
  <section className="px-6 sm:px-8 py-20 sm:py-28" data-testid="home-offers">
    <div className="max-w-5xl mx-auto">
      <motion.h2 {...REVEAL} className="font-fraunces font-extrabold text-3xl sm:text-4xl tracking-tight text-[#1F1F1C]">Our offers</motion.h2>
      <div className="mt-12 grid md:grid-cols-2 gap-5">
        {OFFERS.map((o, i) => (
          <motion.div
            key={o.name}
            {...revealDelayed(i * 0.08)}
            className="card-lift bg-[#EADCC6] rounded-2xl border border-[#1F1F1C]/10 p-8 sm:p-10 flex flex-col"
            data-testid={o.testId}
          >
            <h3 className="font-fraunces font-extrabold text-xl sm:text-2xl text-[#1F1F1C]">{o.name}</h3>
            <p className="mt-3 font-fraunces font-extrabold text-base md:text-lg text-[#C8703A]">{o.price}</p>
            <p className="mt-5 text-sm md:text-base text-[#4A463F] leading-relaxed flex-1">{o.body}</p>
            <Link
              to={o.to}
              className="btn-press mt-8 inline-flex items-center gap-2 self-start rounded-2xl bg-[#C8703A] text-[#F4E9D8] px-6 py-3.5 font-semibold text-sm hover:bg-[#B35F2C]"
              data-testid={`${o.testId}-cta`}
            >
              {o.cta} <ArrowRight className="w-4 h-4" strokeWidth={2.25} />
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default HomeOffers;
